import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import "keen-slider/keen-slider.min.css";
import { VFC } from "react";
import styled from "styled-components";
import { useAnchor } from "hooks";
import { Carousel6Content } from "types/graphql/generated";
import { Carousel6Desktop, Carousel6Mobile, Carousel6TabletHead } from "./components";

interface Props {
  className?: string;
  content: Carousel6Content;
}

const Carousel6: VFC<Props> = withErrorBoundary(({ content }) => {
  useAnchor("carousel6");

  return (
    <StyledCarousel className="carousel6 offices Content">
      <Carousel6TabletHead content={content} className="Carousel6__tabletHeadContainer" />
      <Carousel6Desktop content={content} className="Carousel6__desktop" />
      <Carousel6Mobile content={content} className="Carousel6__mobile" />
    </StyledCarousel>
  );
}, {});

const StyledCarousel = styled.section`
  padding-top: 96px;
  margin-top: -96px;

  .Carousel6__tabletHeadContainer {
    display: none;
  }

  .Carousel6__desktop {
    display: flex;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    .Carousel6__tabletHeadContainer {
      display: block;
    }

    .Carousel6__desktop {
      margin-top: 80px;
    }
  }

  @media (max-width: 660px) {
    .Carousel6__desktop {
      display: none;
    }

    .Carousel6__mobile {
      margin-top: 48px;
    }
  }
`;

gql`
  fragment Carousel6Content on ComponentCarouselCarousel6 {
    title
    description
    carousel6Options {
      id
      optionName
      employeesCount
      openingDate
      addressLink
      addressLabel
      image {
        data {
          image: attributes {
            src: hash
            alt: alternativeText
          }
        }
      }
    }
  }
`;

export { Carousel6 };
export type { Props as Carousel6Props };
